import { type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { Typography } from '@gto/ui/typography'

type SectionHeaderProps = {
  title: ReactNode
  editing: boolean
  onEdit: () => void
  onSave: () => void
  onCancel: () => void
  saving: boolean
}

export const SectionHeader = ({
  title,
  editing,
  onEdit,
  onSave,
  onCancel,
  saving,
}: SectionHeaderProps) => (
  <div className="flex items-center justify-between">
    <Typography
      className="font-semibold"
      variant="subtitle1"
    >
      {title}
    </Typography>
    {editing ? (
      <div className="flex flex-row gap-2">
        <Button
          color="secondary"
          size="small"
          variant="outlined"
          onClick={onCancel}
        >
          <FormattedMessage id="admin.common.cancel" />
        </Button>
        <Button
          disabled={saving}
          size="small"
          type="submit"
          variant="contained"
          onClick={onSave}
        >
          <FormattedMessage id="admin.common.save" />
        </Button>
      </div>
    ) : (
      <Button
        size="small"
        variant="outlined"
        onClick={onEdit}
      >
        <FormattedMessage id="profile.edit" />
      </Button>
    )}
  </div>
)
